{
  "codexEntityForm": {
    "character": "Personaje",
    "place": "Lugar",
    "faction": "Facción",
    "object": "Objeto",
    "concept": "Concepto",
    "editName": "Editar {{name}}",
    "newCodexEntry": "Nueva entrada del Códice",
    "theWorldHasChangedTheDraft": "El mundo ha cambiado. El borrador se conserva; recarga la entrada antes de guardar.",
    "portraitChooseAnImage": "Retrato: elige una imagen",
    "change": "Cambiar",
    "addPortrait": "Añadir retrato",
    "portraitImage": "Imagen del retrato",
    "entryName": "Nombre de la entrada",
    "name": "Nombre",
    "entryType": "Tipo de entrada",
    "customCategory": "Categoría propia",
    "categoryEGDeityShipSpell": "Categoría, p. ej. Deidad, Barco, Hechizo",
    "aliases": "Alias",
    "entryAliases": "Alias de la entrada",
    "otherNamesOneAtATime": "Otros nombres, de uno en uno…",
    "tags": "Etiquetas",
    "entryTags": "Etiquetas de la entrada",
    "themesRolesArcs": "Temas, roles, arcos…",
    "collection": "Colección",
    "entryCollection": "Colección de la entrada",
    "noCustomCollection": "Sin colección propia",
    "folder": "Carpeta",
    "entryFolder": "Carpeta de la entrada",
    "unfiled": "Sin carpeta",
    "notes": "Notas",
    "entryNotes": "Notas de la entrada",
    "whoTheyAreWhatTheyWant": "Quién es, qué quiere, qué no debe descubrir el lector demasiado pronto…",
    "entryFields": "Campos de la entrada",
    "fields": "Campos",
    "fieldTemplate": "Plantilla de campos",
    "template": "Plantilla…",
    "schemaOf": "Esquema de",
    "addMissingFields": "Añadir los campos que faltan",
    "addField": "Añadir campo",
    "noCustomFieldYetFieldsGive": "Aún no hay campos propios. Los campos dan a una entrada datos estructurados (edad, lealtad, un secreto) sobre los que las Comprobaciones pueden razonar.",
    "sharedFieldNamesTypesAndOptions": "Los nombres, tipos y opciones de los campos compartidos se gestionan en los ajustes de la colección. Los valores pertenecen a esta página.",
    "fieldNameN": "Nombre del campo {{n}}",
    "fieldName": "Nombre del campo",
    "fieldTypeN": "Tipo del campo {{n}}",
    "unknown": "Desconocido",
    "fieldValueN": "Valor del campo {{n}}",
    "select": "Seleccionar…",
    "yes": "Sí",
    "no": "No",
    "value": "Valor",
    "chooseAnEntry": "Elige una entrada…",
    "eGSpringOfYear12": "p. ej. Primavera del año 12, o el día del asedio",
    "below": "Debajo",
    "unknownValueN": "Valor desconocido {{n}}",
    "required": "Obligatorio",
    "sharedField": "Campo compartido",
    "remove": "Quitar",
    "confirmRemoval": "Confirmar la eliminación",
    "paragraph": "Párrafo",
    "aFewLines": "Unas líneas…",
    "discardTheDraft": "¿Descartar el borrador?",
    "confirmReload": "Confirmar la recarga",
    "keepEditing": "Seguir editando",
    "reloadEntry": "Recargar la entrada",
    "cancel": "Cancelar",
    "chooseAnImageFileForThe": "Elige un archivo de imagen para el retrato.",
    "thePortraitMustBeUnder8": "El retrato debe pesar menos de 8 MiB.",
    "saveEntry": "Guardar entrada",
    "searchEntries": "Buscar entradas…"
  },
  "codexEntryDialog": {
    "newCodexEntry": "Nueva entrada del Códice",
    "savedToWorldCodexTheManuscript": "Guardada en Mundo › Códice; el manuscrito la mencionará donde estabas escribiendo.",
    "createAndMention": "Crear y mencionar"
  },
  "continuityPanel": {
    "relationsOverTime": "Relaciones a lo largo del tiempo",
    "checkingRelations": "Comprobando las relaciones…",
    "cancel": "Cancelar",
    "theProjectHasChangedRunThe": "El manuscrito o el mundo han cambiado desde esta ejecución. Vuelve a ejecutar las comprobaciones para actualizar las relaciones.",
    "anAnalysisLimitWasReachedThe": "Se alcanzó un límite del análisis. El resultado es parcial.",
    "ruleApplied": "Regla: «{{label}}», {{rule}}.",
    "oneSourcePerTarget": "un origen por cada destino",
    "oneTargetPerSource": "un destino por cada origen",
    "interval": "de {{start}} a {{end}}",
    "openScene": "Abrir {{scene}}",
    "findingReferenceMissing": "Apunta a una entrada que ya no existe.",
    "findingConfirmedWithoutEvidence": "Confirmada sin una cita del texto, así que no se puede comprobar su fuente.",
    "findingEvidenceMissing": "Ha desaparecido una cita en la que se apoya.",
    "findingEvidenceNotCurrent": "Una cita en la que se apoya no está confirmada o ya no coincide con el texto.",
    "findingExclusiveNotEvaluable": "No se puede comprobar con la regla: necesita una dirección, ambos extremos y un intervalo de tiempo completo.",
    "findingExclusiveOverlap": "Dos de estas se cumplen a la vez, y la regla no lo permite.",
    "findingOther": "Algo que revisar en esta relación.",
    "theProjectExceedsTheLimitOf": "El proyecto supera el límite de este análisis. No se cambió ningún dato.",
    "theAnalysisExceededItsExecutionLimit": "El análisis superó su límite de ejecución. No se cambió ningún dato.",
    "analysisCancelled": "Análisis cancelado.",
    "checksNotCompletedTheTextAnd": "Comprobaciones sin terminar. No se cambiaron el texto ni el canon."
  },
  "eventTimelinePanel": {
    "eventHistory": "Historial de eventos",
    "timeline": "Cronología",
    "newEvent": "Nuevo evento",
    "searchEvents": "Buscar eventos",
    "searchEvents2": "Buscar eventos…",
    "timelineOrder": "Orden de la cronología",
    "storyTime": "Tiempo de la historia",
    "readingOrder": "Orden de lectura",
    "dateStatus": "Estado de la fecha",
    "allDates": "Todas las fechas",
    "resolvedDates": "Fechas resueltas",
    "unresolvedDates": "Fechas sin resolver",
    "filterEventsByScene": "Filtrar eventos por escena",
    "allScenes": "Todas las escenas",
    "scenes": "Escenas",
    "editEvent": "Editar evento",
    "closeEventEditor": "Cerrar el editor de eventos",
    "theWorldHasChangedReloadThe": "El mundo ha cambiado. Recarga el evento antes de guardar; los campos del borrador se conservan.",
    "eventTitle": "Título del evento",
    "whatHappens": "Qué ocurre",
    "scene": "Escena",
    "eventScene": "Escena del evento",
    "notLinked": "Sin vincular",
    "removedSceneSceneid": "Escena eliminada — {{sceneId}}",
    "dateType": "Tipo de fecha",
    "eventDateType": "Tipo de fecha del evento",
    "unknown": "Desconocida",
    "definedInterval": "Intervalo definido",
    "relativeToAnEvent": "Relativa a un evento",
    "start": "Inicio",
    "eventStart": "Inicio del evento",
    "endExclusive": "Fin (excluido)",
    "eventEnd": "Fin del evento",
    "referenceEvent": "Evento de referencia",
    "select": "Seleccionar…",
    "referenceToVerifyAnchoreventid": "Referencia por verificar — {{anchorEventId}}",
    "events": "Eventos",
    "offsetInTicks": "Desfase en ticks",
    "eventOffset": "Desfase del evento",
    "saveEvent": "Guardar evento",
    "closeReload": "Cerrar / recargar…",
    "discardTheDraftChanges": "¿Descartar los cambios del borrador?",
    "discardDraft": "Descartar borrador",
    "reloadEvent": "Recargar evento",
    "keepEditing": "Seguir editando",
    "noEventMatchesTheseFiltersEvents": "Ningún evento coincide con estos filtros. Los eventos son aquello sobre lo que razonan las Comprobaciones: cuándo ocurrió algo y en qué escena se entera el lector.",
    "tickStart": "Tick {{start}}",
    "openScene": "Abrir escena",
    "editTitle": "Editar {{title}}",
    "removeTitle": "Quitar {{title}}",
    "confirmEventRemoval": "Confirmar la eliminación del evento",
    "cancel": "Cancelar",
    "theWorldHasChangedCancelAnd": "El mundo ha cambiado: cancela y vuelve a abrir la confirmación.",
    "resolvedDate": "Fecha resuelta",
    "unknownDate": "Fecha desconocida",
    "missingReference": "Referencia ausente",
    "timeCycle": "Ciclo temporal",
    "dateOutOfRange": "Fecha fuera de rango",
    "eventsFoundOfTotal_one": "{{count}} evento encontrado · {{total}} en total",
    "eventsFoundOfTotal_many": "{{count}} eventos encontrados · {{total}} en total",
    "eventsFoundOfTotal_other": "{{count}} eventos encontrados · {{total}} en total",
    "removeThisEventReferences_one": "¿Quitar este evento? Habrá que revisar {{count}} referencia directa.",
    "removeThisEventReferences_many": "¿Quitar este evento? Habrá que revisar {{count}} referencias directas.",
    "removeThisEventReferences_other": "¿Quitar este evento? Habrá que revisar {{count}} referencias directas.",
    "showMoreEvents_one": "Mostrar {{count}} evento más",
    "showMoreEvents_many": "Mostrar {{count}} eventos más",
    "showMoreEvents_other": "Mostrar {{count}} eventos más"
  },
  "fieldEditor": {
    "choose": "Elegir…",
    "labelSearch": "Búsqueda de {{label}}",
    "search": "Buscar…",
    "labelOptions": "Opciones de {{label}}",
    "noMatch": "Sin coincidencias.",
    "optionsOnePerLine": "Opciones, una por línea",
    "fieldOptionsIndex": "Opciones del campo {{index}}",
    "addOptionIndex": "Añadir opción {{index}}",
    "newOption": "Nueva opción",
    "addOption": "Añadir opción",
    "fieldValueIndex": "Valor del campo {{index}}",
    "chooseOptions": "Elegir opciones…",
    "chooseEntries": "Elegir entradas…",
    "unsupportedMultiValueEditor": "Editor de valores múltiples no compatible"
  },
  "graphExplorer": {
    "relationGraph": "Grafo de relaciones",
    "entry": "Entrada",
    "filterGraphByEntry": "Filtrar el grafo por entrada",
    "all": "Todas",
    "status": "Estado",
    "graphRelationStatus": "Estado de las relaciones del grafo",
    "proposedAndConfirmed": "Propuestas y confirmadas",
    "confirmed": "Confirmadas",
    "proposed": "Propuestas",
    "relation": "Relación",
    "searchRelationInTheGraph": "Buscar una relación en el grafo",
    "filterAtStoryTime": "Filtrar por tiempo de la historia",
    "tick": "Tick",
    "graphTick": "Tick del grafo",
    "includeUnknownTime": "Incluir tiempo desconocido",
    "enterANumericTickOrTurn": "Escribe un tick numérico o desactiva el filtro de tiempo.",
    "navigableRelationGraph": "Grafo de relaciones navegable",
    "selectName": "Seleccionar {{name}}",
    "entryCount_one": "{{count}} entrada",
    "entryCount_many": "{{count}} de entradas",
    "entryCount_other": "{{count}} entradas",
    "relationCount_one": "{{count}} relación",
    "relationCount_many": "{{count}} de relaciones",
    "relationCount_other": "{{count}} relaciones",
    "hiddenBeyondViewLimit": "{{entries}} y {{relations}} fuera del límite de la vista.",
    "relationsWithMissingEntries_one": "{{count}} relación con entradas ausentes.",
    "relationsWithMissingEntries_many": "{{count}} relaciones con entradas ausentes.",
    "relationsWithMissingEntries_other": "{{count}} relaciones con entradas ausentes.",
    "unknownDurationIncluded_one": "{{count}} relación de duración desconocida incluida en el filtro.",
    "unknownDurationIncluded_many": "{{count}} relaciones de duración desconocida incluidas en el filtro.",
    "unknownDurationIncluded_other": "{{count}} relaciones de duración desconocida incluidas en el filtro.",
    "unknownDurationExcluded_one": "{{count}} relación de duración desconocida excluida del filtro.",
    "unknownDurationExcluded_many": "{{count}} relaciones de duración desconocida excluidas del filtro.",
    "unknownDurationExcluded_other": "{{count}} relaciones de duración desconocida excluidas del filtro."
  },
  "relationshipPanel": {
    "select": "Seleccionar…",
    "removedReference": "Referencia eliminada:",
    "projectRelations": "Relaciones del proyecto",
    "relationsOf": "Relaciones de",
    "filterRelationsByEntry": "Filtrar relaciones por entrada",
    "allEntries": "Todas las entradas",
    "searchEntries": "Buscar entradas…",
    "searchRelations": "Buscar relaciones",
    "relationOrEntry": "Relación o entrada",
    "newRelation": "Nueva relación",
    "editRelation": "Editar relación",
    "relationsLinkTwoEntries": "Las relaciones unen dos entradas",
    "addTwoEntriesInTheCodex": "Añade al menos dos entradas en el Códice y escribe las palabras que las unen, como «es el mentor de».",
    "theWorldHasChangedTheFields": "El mundo cambió mientras esto estaba abierto. Tus campos se conservan; recarga para guardar sobre los datos nuevos.",
    "reload": "Recargar",
    "anEntry": "Una entrada",
    "anotherEntry": "Otra entrada",
    "relationSource": "Origen de la relación",
    "relationType": "Tipo de relación",
    "isTheMentorOf": "es el mentor de",
    "relationTarget": "Destino de la relación",
    "direction": "Dirección",
    "relationDirection": "Dirección de la relación",
    "oneWay": "En un sentido",
    "bothWays": "En ambos sentidos",
    "when": "Cuándo",
    "relationTime": "Tiempo de la relación",
    "notSet": "Sin definir",
    "betweenTwoMoments": "Entre dos momentos",
    "fromAnEvent": "A partir de un evento",
    "from": "Desde",
    "to": "hasta",
    "relationStart": "Inicio de la relación",
    "relationEnd": "Fin de la relación",
    "momentsHint": "Momentos de la cronología del mundo; el final no se incluye.",
    "event": "Evento",
    "relationEvent": "Evento de la relación",
    "offset": "Desfase",
    "relationOffset": "Desfase de la relación",
    "offsetHint": "Momentos después del evento; negativo para antes.",
    "status": "Estado",
    "relationStatus": "Estado de la relación",
    "proposed": "Propuesta",
    "confirmed": "Confirmada",
    "rejected": "Rechazada",
    "superseded": "Reemplazada",
    "confirmedRelationsCountAsCanonIn": "Las relaciones confirmadas cuentan como canon en las Comprobaciones.",
    "notes": "Notas",
    "relationNotes": "Notas de la relación",
    "howTheStoryShowsItAnd": "Cómo la muestra la historia y qué queda ambiguo.",
    "quotes": "Citas",
    "linkQuotes": "Vincular citas del texto",
    "quotesLinked": "Citas: {{count}}",
    "searchQuotations": "Buscar citas",
    "excerptOrNote": "Fragmento o nota",
    "removedQuotation": "Cita eliminada:",
    "noQuotationYetAnnotateAPassage": "Aún no hay citas. Anota un pasaje del manuscrito para citarlo aquí.",
    "upTo100QuotationsShownUse": "Se muestran hasta 100 citas. Usa la búsqueda para acotar la lista.",
    "saveRelation": "Guardar relación",
    "cancel": "Cancelar",
    "aDeletedEntry": "una entrada eliminada",
    "aDeletedEvent": "un evento eliminado",
    "timeBetween": "De {{start}} a {{end}}",
    "timeAtEvent": "En {{event}}",
    "timeAfterEvent": "{{event}} + {{offset}}",
    "timeBeforeEvent": "{{event}} − {{offset}}",
    "noRelationsYet": "Aún no hay relaciones.",
    "noRelationMatches": "Ninguna relación coincide.",
    "edit": "Editar",
    "editCaption": "Editar {{caption}}",
    "remove": "Quitar",
    "removeCaption": "Quitar {{caption}}",
    "removeThisRelationTheChangeStays": "¿Quitar esta relación? El cambio queda en el historial.",
    "confirmRemoval": "Quitar",
    "shownOfTotal": "Se muestran 100 de {{total}} relaciones. Acota la búsqueda para ver las demás.",
    "theWorldHasChangedReloadThe": "El mundo ha cambiado. Recarga la relación antes de guardar.",
    "theRelationWasChangedOrRemoved": "La relación se cambió o se quitó. Recarga los datos.",
    "explicitlyConfirmTheRelationBeforeSaving": "Elige Confirmada de nuevo para que esta relación sea canon.",
    "selectTwoEntriesThatExistIn": "Selecciona dos entradas que existan en el Códice.",
    "fillInTheTimeValuesOr": "Rellena los momentos o elige Sin definir.",
    "enterAValidIntervalTheEnd": "El final debe ser posterior al inicio.",
    "selectAnExistingEventAsThe": "Elige un evento que todavía exista.",
    "theSelectedQuotationIsNoLonger": "Una de las citas elegidas ya no existe.",
    "checkTheRelationTextAndThe": "Revisa el texto de la relación y las notas.",
    "theChangeWasNotSavedReload": "No se guardó el cambio. Recarga los datos e inténtalo de nuevo."
  },
  "useWorldReplication": {
    "signInToTheLinkedAccount": "Inicia sesión en la cuenta vinculada y revisa el acceso a tu proyecto. Tus cambios locales se conservan.",
    "syncTheManuscriptWithThisServer": "Sincroniza el manuscrito con este servidor antes de vincular su Mundo.",
    "theWorldChangedAfterTheComparison": "El Mundo cambió después de la comparación. Revisa de nuevo las copias actuales.",
    "aConfirmationOrRestoredRecordNeeds": "Una confirmación o un registro restaurado necesita una revisión explícita antes de poder sincronizarse.",
    "anAttachmentOrRemoteCopyFailed": "Un adjunto o una copia remota no superó la verificación. Tu Mundo local se conserva.",
    "theseChangesExceedASyncLimit": "Estos cambios superan un límite de sincronización o deben aplicarse juntos. Tu Mundo local y los cambios pendientes se conservan.",
    "syncPausedYourLocalChangesAre": "Sincronización en pausa. Tus cambios locales se conservan.",
    "newMapNeedsPlan": "Los mapas nuevos están incluidos en Ink y Press. El mapa se queda en este dispositivo y el Mundo espera: quita el mapa nuevo o elige un plan para volver a sincronizarlo.",
    "worldSyncCouldNotFinishCheck": "La sincronización del Mundo no pudo terminar. Revisa la conexión e inténtalo de nuevo. Tus cambios locales se conservan."
  },
  "vaultFolders": {
    "folderName": "Carpeta {{name}}",
    "editFolder": "Editar carpeta",
    "newSubfolder": "Nueva subcarpeta",
    "moveContentsBeforeRemoving": "Mueve el contenido antes de quitarla",
    "removeFolder": "Quitar carpeta",
    "folderActionsName": "Acciones de la carpeta {{name}}",
    "chooseThisFolderWhenEditingA": "Elige esta carpeta al editar una página.",
    "projectFolders": "Carpetas del proyecto",
    "folders": "Carpetas",
    "newFolder": "Nueva carpeta",
    "groupPagesFromAnyCollection": "Agrupa páginas de cualquier colección.",
    "foldersOrganizePagesWithoutChangingTheir": "Las carpetas organizan las páginas sin cambiar su colección ni su contenido.",
    "cancel": "Cancelar",
    "saveFolder": "Guardar carpeta",
    "name": "Nombre",
    "folderName2": "Nombre de la carpeta",
    "inside": "Dentro de",
    "parentFolder": "Carpeta superior",
    "projectRoot": "Raíz del proyecto",
    "removeEmptyFolder": "¿Quitar la carpeta vacía?",
    "removeNameFromTheProject": "¿Quitar «{{name}}» del proyecto?"
  },
  "vaultTable": {
    "unavailableEntry": "Entrada no disponible",
    "vaultTable": "Tabla de la bóveda",
    "pages": "Páginas",
    "searchVaultTable": "Buscar en la tabla de la bóveda",
    "searchPages": "Buscar páginas…",
    "tableCollection": "Colección de la tabla",
    "allCollections": "Todas las colecciones",
    "noCustomCollection": "Sin colección propia",
    "tableFolder": "Carpeta de la tabla",
    "allFolders": "Todas las carpetas",
    "unfiled": "Sin carpeta",
    "scrollableVaultTable": "Tabla de la bóveda con desplazamiento",
    "name": "Nombre",
    "collection": "Colección",
    "folder": "Carpeta",
    "noPagesMatchTheseFilters": "Ninguna página coincide con estos filtros.",
    "none": "Ninguno",
    "yes": "Sí",
    "no": "No",
    "pagesShown_one": "{{shown}} de {{count}} página",
    "pagesShown_many": "{{shown}} de {{count}} páginas",
    "pagesShown_other": "{{shown}} de {{count}} páginas"
  },
  "vaultTree": {
    "blue": "Azul",
    "emerald": "Esmeralda",
    "gold": "Oro",
    "violet": "Violeta",
    "rose": "Rosa",
    "amber": "Ámbar",
    "teal": "Verde azulado",
    "slate": "Pizarra",
    "crimson": "Carmesí",
    "bark": "Corteza",
    "forest": "Bosque",
    "navy": "Azul marino",
    "orchid": "Orquídea",
    "saffron": "Azafrán",
    "ink": "Tinta",
    "ember": "Brasa",
    "concept": "Concepto",
    "character": "Personaje",
    "place": "Lugar",
    "faction": "Facción",
    "object": "Objeto",
    "vault": "Bóveda",
    "newCollection": "Nueva colección",
    "vaultView": "Vista de la bóveda",
    "pages": "Páginas",
    "table": "Tabla",
    "pagesMarkedUnassignedKeepTheirPrevious": "Las páginas marcadas como sin asignar conservan sus campos anteriores. Edita una página para elegir su colección.",
    "filterPages": "Filtrar páginas",
    "filterPages2": "Filtrar páginas…",
    "worldVault": "Bóveda del mundo",
    "removeCollectionName": "Quitar la colección {{name}}",
    "collectionSettingsForName": "Ajustes de la colección {{name}}",
    "iconAndColour": "Icono y color",
    "newPageInName": "Nueva página en {{name}}",
    "noPageYetAddTheFirst": "Aún no hay páginas: añade la primera con +.",
    "nothingHereYet": "Aquí aún no hay nada.",
    "removeEmptyCollection": "¿Quitar la colección vacía?",
    "removeNameAndItsSchema": "¿Quitar «{{name}}» y su esquema?",
    "removeCollection": "Quitar colección",
    "text": "Texto",
    "theSvgMustBeUnder16": "El SVG debe pesar menos de 16 KiB.",
    "thisFileIsNotAUsable": "Este archivo no es un SVG utilizable (se eliminan los scripts y las referencias externas; la raíz debe ser <svg>).",
    "collectionName": "Colección: {{name}}",
    "sharedFieldsApplyToEveryPage": "Los campos compartidos se aplican a todas las páginas de esta colección. Cada página también puede tener sus propios campos.",
    "cancel": "Cancelar",
    "saving": "Guardando…",
    "saveCollection": "Guardar colección",
    "createCollection": "Crear colección",
    "identity": "Identidad",
    "nameAndIconAsTheTree": "Nombre e icono, tal como los mostrarán el árbol y las páginas.",
    "name": "Nombre",
    "collectionName2": "Nombre de la colección",
    "magic": "Magia",
    "aCollectionWithThisNameAlready": "Ya existe una colección con este nombre.",
    "icon": "Icono",
    "iconSource": "Origen del icono",
    "lucide181": "Lucide (181)",
    "yourSvg": "Tu SVG",
    "collectionIcon": "Icono de la colección",
    "searchLucideIcons": "Buscar iconos de Lucide",
    "searchIconsCastleSwordMoon": "Buscar iconos: castillo, espada, luna…",
    "loadingIcons": "Cargando iconos…",
    "lucideIcon": "Icono de Lucide",
    "noIconMatches": "Ningún icono coincide.",
    "chooseAnSvgFile": "Elige un archivo SVG",
    "customSvgIcon": "Icono SVG propio",
    "upTo16KibScriptsLinks": "Hasta 16 KiB. Se eliminan los scripts, los enlaces y las referencias externas; usa currentColor en el archivo para que se aplique el color de la colección.",
    "colour": "Color",
    "aPresetOneYouUsedRecently": "Uno predefinido, uno que usaste hace poco o uno propio con la rueda.",
    "collectionColour": "Color de la colección",
    "recent": "Recientes",
    "useHex": "Usar {{hex}}",
    "kindOfPage": "Tipo de página",
    "everyPageIsACodexEntry": "Cada página es una entrada del Códice de un tipo; el tipo decide cómo la tratan las Comprobaciones, las menciones con @ y el grafo, y conserva su color en todas partes.",
    "collectionBaseKind": "Tipo base de la colección",
    "magicOrShipsConceptDeitiesOr": "Magia o Barcos → Concepto · Deidades o Casas → Personaje o Facción · una colección de pueblos → Lugar.",
    "sharedFields": "Campos compartidos",
    "thePropertiesOfTheCollectionValues": "Las propiedades de la colección: los valores viven en cada página y una página aún puede añadir los suyos.",
    "collectionTemplate": "Plantilla de la colección",
    "template": "Plantilla…",
    "addField": "Añadir campo",
    "exampleMagicLevelNumberRarityChoice": "Ejemplo: Magia → Nivel (número) · Rareza (opción: común, rara, legendaria) · Obtenido (fecha de la historia) · Enseñado por (enlace a una entrada).",
    "collectionFieldNameValue": "Nombre del campo de colección {{value}}",
    "fieldName": "Nombre del campo",
    "collectionFieldTypeValue": "Tipo del campo de colección {{value}}",
    "collectionFieldOptionsValue": "Opciones del campo de colección {{value}}",
    "optionsOnePerLine": "Opciones, una por línea",
    "required": "Obligatorio",
    "requiredCollectionFieldValue": "Campo de colección obligatorio {{value}}",
    "removeCollectionFieldValue": "Quitar el campo de colección {{value}}",
    "yesNo": "Sí / No",
    "multipleChoice": "Opción múltiple",
    "storyDate": "Fecha de la historia",
    "entryLink": "Enlace a una entrada",
    "multipleEntryLinks": "Varios enlaces a entradas",
    "fieldParagraph": "Párrafo",
    "fieldNumber": "Número",
    "fieldChoice": "Opción"
  },
  "worldCloudPanel": {
    "worldCloudVersions": "Versiones del Mundo en la nube",
    "includesCodexPagesCollectionsFoldersFacts": "Incluye las páginas del Códice, las colecciones, las carpetas, los datos, las relaciones y los adjuntos. Publica o descarga una versión de forma explícita. El manuscrito usa la sincronización por escenas.",
    "compareVersions": "Comparar versiones",
    "recoverPreviousWorld": "Recuperar el Mundo anterior…",
    "deviceRevision": "Revisión del dispositivo",
    "accountVersionRemoteversion": "Versión de la cuenta {{remoteVersion}}",
    "firstAccountVersion": "Primera versión de la cuenta",
    "uploadDeviceVersion": "Subir la versión del dispositivo…",
    "useAccountVersion": "Usar la versión de la cuenta…",
    "confirmTransfer": "Confirmar la transferencia",
    "replaceWorldOnThisDeviceWith": "¿Reemplazar el Mundo de este dispositivo por esta versión? Antes se conservará una copia del Mundo y los adjuntos actuales. El texto del manuscrito no cambia.",
    "saveThisCopyToYourAccount": "¿Guardar esta copia en tu cuenta? Se conservarán las versiones anteriores de la cuenta.",
    "restoreWorldFromBeforeTheLast": "¿Restaurar el Mundo anterior a la última transferencia? Las ediciones posteriores impiden esta restauración.",
    "confirm": "Confirmar",
    "cancel": "Cancelar",
    "transferring": "Transfiriendo…",
    "codexPages": "Páginas del Códice",
    "updateStoryideBeforePublishingChangesTo": "Actualiza Musael antes de publicar cambios en esta Bóveda.",
    "theAccountVersionChangedCompareAgain": "La versión de la cuenta ha cambiado. Compara de nuevo antes de aplicar.",
    "worldChangedOnThisDeviceCompare": "El Mundo ha cambiado en este dispositivo. Compara de nuevo antes de aplicar.",
    "accountVersionStorageIsFullPrevious": "El almacenamiento de versiones de la cuenta está lleno. Se conservan las copias anteriores.",
    "anAttachmentFailedItsIntegrityCheck": "Un adjunto no superó la comprobación de integridad. No se reemplazó ninguna copia local.",
    "theAccountCopyFailedItsIntegrity": "La copia de la cuenta no superó la comprobación de integridad.",
    "noRecoveryCopyIsAvailableFor": "No hay ninguna copia de recuperación disponible para esta transferencia.",
    "anIdentifierIsAlreadyUsedIn": "Un identificador ya se usa en otro proyecto.",
    "openOrSyncTheManuscriptWith": "Abre o sincroniza antes el manuscrito con tu cuenta.",
    "yourAccountDoesNotHaveThe": "Tu cuenta no tiene el permiso necesario.",
    "signInAgainThisSessionWas": "Inicia sesión de nuevo. Esta sesión fue revocada.",
    "transferCancelled": "Transferencia cancelada.",
    "transferFailedCheckYourConnectionAnd": "La transferencia falló. Revisa tu conexión y compara de nuevo.",
    "couldNotReadTheRecoveryCopy": "No se pudo leer la copia de recuperación.",
    "mondoPrecedenteRipristinato": "Mundo anterior restaurado.",
    "accountVersionVersionSaved": "Versión {{version}} de la cuenta guardada.",
    "versionVersionAppliedToWorldOn": "Versión {{version}} aplicada al Mundo de este dispositivo.",
    "cancellationRequested": "Cancelación solicitada.",
    "labelFacts": "Hechos",
    "labelEvents": "Eventos",
    "labelKnowledge": "Conocimiento",
    "labelAnnotations": "Anotaciones",
    "labelRelationships": "Relaciones",
    "labelAttachments": "Adjuntos",
    "labelCollections": "Colecciones",
    "labelFolders": "Carpetas",
    "changedCount_one": "{{count}} modificado",
    "changedCount_many": "{{count}} modificados",
    "changedCount_other": "{{count}} modificados"
  },
  "worldMaps": {
    "character": "Personaje",
    "place": "Lugar",
    "object": "Objeto",
    "faction": "Facción",
    "concept": "Concepto",
    "pinOf": "Marcador: {{name}}",
    "pinMissing": "Marcador de una entrada ausente",
    "missingEntry": "Entrada ausente",
    "zoom": "Zoom",
    "zoomIn": "Acercar",
    "zoomOut": "Alejar",
    "fitToView": "Ajustar a la vista",
    "newMap": "Nuevo mapa",
    "newMapDescription": "Una imagen de un lugar, para colocar marcadores sobre las personas, los lugares y las cosas que hay en él.",
    "cancel": "Cancelar",
    "saving": "Guardando…",
    "createMap": "Crear mapa",
    "mapOf": "Mapa de",
    "aNewPlace": "Un lugar nuevo",
    "placeName": "Nombre del lugar",
    "placeNamePlaceholder": "La Costa de Sal",
    "picture": "Imagen",
    "choosePicture": "Elige un PNG, JPEG, WebP o GIF",
    "pictureHint": "Hasta 16 MB. Pasa a ser uno de los adjuntos de la entrada.",
    "maps": "Mapas",
    "mapsLead": "Coloca marcadores de entradas sobre las imágenes de tus lugares. Un lugar marcado que tenga mapa propio lo abre.",
    "noMapsYet": "Aún no hay mapas",
    "noMapsText": "Dale una imagen a un lugar y coloca en ella las entradas que le pertenecen.",
    "addTheFirstMap": "Añadir el primer mapa",
    "onePin": "1 marcador",
    "pins": "{{count}} marcadores",
    "inPlace": "en {{place}}",
    "chooseAnEntryOrName": "Elige una entrada o escribe un nombre para el marcador.",
    "mapTrail": "Mapas superiores a este",
    "doneAdding": "Listo",
    "addPin": "Añadir marcador",
    "labels": "Etiquetas",
    "replacePicture": "Reemplazar imagen",
    "removeMap": "Quitar mapa",
    "hintClick": "Haz clic en el mapa donde va el marcador.",
    "hintChoose": "Elige a qué apunta el marcador, a la derecha.",
    "pictureMissing": "La imagen de este mapa aún no está en este dispositivo.",
    "pinDetails": "Detalles del marcador",
    "newPin": "Nuevo marcador",
    "entry": "Entrada",
    "chooseAnEntry": "Elige una entrada",
    "noEntryLabelOnly": "Sin entrada, solo una etiqueta",
    "labelOnTheMap": "Etiqueta en el mapa",
    "labelDefault": "El nombre de la entrada",
    "labelRequired": "Necesaria si no hay entrada",
    "placePin": "Colocar marcador",
    "label": "Etiqueta",
    "openEntry": "Abrir entrada",
    "openItsMap": "Abrir su mapa",
    "position": "{{x}}% a lo ancho, {{y}}% a lo alto",
    "removePin": "Quitar marcador",
    "noPinsYet": "Aún no hay marcadores. Usa Añadir marcador y haz clic en el mapa.",
    "shownOn": "Aparece en",
    "openEntryOf": "Abrir {{name}}",
    "removeMapTitle": "¿Quitar el mapa de {{name}}?",
    "removeMapMessage": "Los marcadores se van con él. La imagen se queda en los adjuntos de la entrada."
  },
  "worldPanel": {
    "checks": "Comprobaciones",
    "findAndFixConsistencyIssuesIn": "Los datos, eventos y relaciones de tu mundo comparados con el manuscrito. Sin IA.",
    "running": "Ejecutando…",
    "runChecks": "Ejecutar comprobaciones",
    "lastRunAt": "Última ejecución: {{time}}",
    "oneAtATime": "De una en una",
    "exclusiveRelation": "Relación exclusiva",
    "noRelationIsExclusive": "Ninguna relación es exclusiva",
    "exclusivityType": "Tipo de exclusividad",
    "oneSourcePerTarget": "Un origen por cada destino",
    "oneTargetPerSource": "Un destino por cada origen",
    "oneAtATimeHint": "Una relación que solo puede cumplirse para uno a la vez, como «posee»: dos propietarios de lo mismo en los mismos momentos se convierten en un conflicto.",
    "rulesNeedRelations": "Las reglas usan tus relaciones. Añade una en Conexiones, como «posee», y hazla exclusiva aquí.",
    "results": "Resultados",
    "whatTheChecksLookFor": "Qué buscan las comprobaciones",
    "twoHoldersAtOnce": "Dos titulares a la vez",
    "eventsOutOfOrder": "Eventos desordenados",
    "quotedPastItsLimit": "Citado más allá de su límite",
    "linksToDeletedEntries": "Enlaces a entradas eliminadas",
    "notesThatLostTheirPlace": "Notas que perdieron su sitio",
    "relationsOverTime": "Relaciones a lo largo del tiempo",
    "scopeOwnership": "Una misma cosa en manos de dos entradas en los mismos momentos, según los datos confirmados.",
    "scopeFlashback": "Un evento leído después de otro que ocurre más tarde en el mundo: un flashback o un descuido.",
    "scopeReveal": "Un dato citado en una escena posterior a la última que permitiste para él.",
    "scopeOrphans": "Notas y datos que apuntan a una entrada o a una ficha de la Biblioteca que ya no existe.",
    "scopeAnchors": "Un pasaje citado cuyas palabras se movieron o cambiaron en su escena.",
    "scopeRelations": "Las relaciones frente a la regla de arriba y frente a las citas en las que se apoyan.",
    "filterResults": "Filtrar resultados",
    "all": "Todos",
    "conflicts": "Conflictos",
    "warnings": "Avisos",
    "needsData": "Faltan datos",
    "noIssuesFound": "No se encontró ningún problema",
    "theExecutedRulesFoundNoViolation": "Nada contradice los datos y las reglas que has fijado. Las comprobaciones solo conocen lo que has registrado.",
    "notEnoughData": "Datos insuficientes",
    "quotesInTheText": "Citas en el texto",
    "anchorInPlace": "En su sitio",
    "anchorMoved": "Movida",
    "anchorGone": "Desaparecida",
    "reAnchor": "Volver a anclar",
    "openScene": "Abrir escena",
    "checkedAt": "Comprobado a las {{time}}.",
    "twoHold": "{{a}} y {{b}} tienen «{{object}}» a la vez.",
    "heldTwice": "{{a}} tiene «{{object}}» dos veces en los mismos momentos.",
    "flashbackSentence": "«{{earlier}}» ocurre antes que «{{later}}» en el mundo, pero se lee después: un flashback, a menos que no lo pretendieras.",
    "revealSentence": "«{{fact}}» se cita en {{scene}}, después de la última escena que permitiste para él.",
    "allowedUpToScene": "Permitido hasta la escena {{scene}}",
    "orphanFactSentence": "Un dato («{{fact}}») trata de una entrada que se eliminó.",
    "orphanNoteSentence": "La nota sobre «{{excerpt}}» apunta a una entrada eliminada.",
    "orphanConceptSentence": "La nota sobre «{{excerpt}}» apunta a una ficha de la Biblioteca que ya no existe.",
    "movedSentence": "«{{excerpt}}» se movió en {{scene}}: vuelve a anclar la nota para que lo siga.",
    "eventWithoutTime": "«{{title}}» no tiene tiempo en el mundo, así que no se puede comprobar su orden.",
    "factWithoutTime": "«{{fact}}» no tiene intervalo de tiempo, así que no se puede comprobar su titular.",
    "recordWithoutTime": "Un registro no tiene tiempo, así que no se puede comprobar.",
    "aDeletedEntry": "una entrada eliminada",
    "aDeletedEvent": "un evento eliminado",
    "aScene": "una escena",
    "fromTo": "De {{start}} a {{end}}",
    "relativeToAnEvent": "Relativo a un evento",
    "timeNotSet": "Sin definir",
    "facts": "Datos",
    "factsLead": "Lo que afirmas sobre cada entrada. Las comprobaciones leen los que confirmas y los comparan con el manuscrito.",
    "entries": "Entradas",
    "addAnEntry": "Añadir una entrada",
    "addTheFirstEntry": "Añadir la primera entrada",
    "newEntityName": "Nombre de la nueva entidad",
    "entityType": "Tipo de entidad",
    "addEntity": "Añadir entidad",
    "character": "Personaje",
    "place": "Lugar",
    "object": "Objeto",
    "faction": "Facción",
    "other": "Otro",
    "deleteEntityReferencesBecomeOrphaned": "Eliminar entidad (las referencias quedan huérfanas)",
    "deleteEntityName": "Eliminar la entidad {{name}}",
    "noFactYet": "Aún no hay datos sobre {{name}}. Un dato nuevo empieza como propuesto; confírmalo para que cuente.",
    "proposed": "Propuesto",
    "confirmed": "Confirmado",
    "rejected": "Rechazado",
    "superseded": "Reemplazado",
    "worldFact": "Dato del mundo",
    "characterBelief": "Creencia",
    "testimony": "Testimonio",
    "authorHypothesis": "Hipótesis",
    "confirm": "Confirmar",
    "confirmExplicitApproval": "Confirmar (aprobación explícita)",
    "newFactAbout": "Nuevo dato sobre {{name}}",
    "predicatePlaceholder": "posee",
    "predicate": "Predicado",
    "valuePlaceholder": "la espada",
    "value": "Valor",
    "kind": "Tipo",
    "epistemicKind": "Tipo epistémico",
    "kindHint": "Solo los datos del mundo cuentan como verdad; las creencias, los testimonios y las hipótesis se conservan, pero no se comprueban como canon.",
    "when": "Cuándo",
    "timeKind": "Tipo de tiempo",
    "betweenTwoMoments": "Entre dos momentos",
    "from": "Desde",
    "to": "hasta",
    "startTick": "Tick de inicio",
    "endTick": "Tick de fin",
    "momentsHint": "Momentos de la cronología del mundo; el final no se incluye.",
    "reveal": "Revelación",
    "maximumRevealNarrativeIndex": "Revelación máxima (índice narrativo)",
    "noLimit": "Sin límite",
    "sceneNumbered": "{{n}}. {{title}}",
    "revealHint": "Se señalan las citas de este dato en una escena posterior.",
    "addFactProposed": "Añadir como propuesto",
    "selectAnEntityToSeeAnd": "Elige una entrada para ver y añadir sus datos.",
    "noEntityYet": "Aún no hay entradas. Añade un personaje, un lugar o un objeto arriba o en el Códice.",
    "resultDetails": "Detalles del resultado",
    "conflict": "Conflicto",
    "warning": "Aviso",
    "whatWasCompared": "Qué se comparó",
    "whatToDo": "Qué hacer",
    "comparedOwnership": "Datos del mundo confirmados con intervalo de tiempo. Dos titulares de lo mismo no pueden solaparse.",
    "comparedFlashback": "El tiempo de cada evento en el mundo frente al orden de su escena en el libro.",
    "comparedReveal": "La última escena que permitiste para un dato frente a las escenas que lo citan.",
    "comparedOrphans": "Cada nota y cada dato frente a las entradas y fichas de la Biblioteca que existen.",
    "comparedAnchors": "La cita de cada nota frente al texto actual de la escena.",
    "confirmOnlyOneOwnerInThe": "Deja un solo titular para esos momentos: acota uno de los intervalos o devuelve uno de los datos a propuesto.",
    "ifTheSceneIsADeliberate": "Si la escena es un flashback intencionado, déjala. Si no, mueve la escena o cambia el tiempo del evento.",
    "raiseTheMaximumRevealSceneOf": "Permite una escena posterior para el dato o mueve la cita a una escena anterior.",
    "restoreTheMissingEntityFromThe": "Restaura la entrada desde el historial del Códice o elimina la nota o el dato que apunta a ella.",
    "useReAnchorManualOnThe": "Usa Volver a anclar en la cita de los resultados, o abre la escena y vuelve a seleccionar el pasaje.",
    "giveTheEventOrFactAn": "Dale un tiempo en el mundo o déjalo sin él: la comprobación se queda en silencio en lugar de adivinar.",
    "selectAResult": "Selecciona un resultado",
    "detailsConstraintsAndSuggestedFixesAppear": "Aquí aparecen lo que se comparó y qué hacer.",
    "thisAnnotationCannotBeReAnchored": "Esta nota no se puede volver a anclar: «{{excerpt}}» falta o aparece más de una vez en la escena.",
    "revisionTools": "Herramientas de revisión",
    "loadingRevisionTools": "Cargando las herramientas de revisión…"
  },
  "worldReplicationPanel": {
    "theContentChangedWhileItWas": "El contenido cambió mientras se confirmaba. Elige el contenido y la aprobación que revisaste.",
    "theseChangesCannotBeCombinedInto": "Estos cambios no se pueden combinar en un Mundo válido. Elige la versión completa que conservar; ambas copias quedan en recuperación.",
    "thisDevice": "Este dispositivo",
    "yourAccount": "Tu cuenta",
    "viewWorld": "Ver el Mundo",
    "previousSharedValue": "Valor compartido anterior",
    "theActionCouldNotFinishYour": "La acción no pudo terminar. Tus cambios locales se conservan.",
    "worldSync": "Sincronización del Mundo",
    "syncCodexPagesFactsTimelinesCollections": "Sincroniza entre dispositivos las páginas del Códice, los datos, las cronologías, las colecciones y los adjuntos. Las notas y los bocetos se sincronizan por su cuenta, más abajo.",
    "syncWorldAutomatically": "Sincronizar el Mundo automáticamente",
    "n1PendingChange": "1 cambio pendiente",
    "pendingPendingChanges": "{{pending}} cambios pendientes",
    "syncNow": "Sincronizar ahora",
    "exportRecoveryCopies": "Exportar copias de recuperación",
    "compareBeforeSyncing": "Comparar antes de sincronizar",
    "signInToTheLinkedAccount": "Inicia sesión en la cuenta vinculada para sincronizar. Los cambios locales siguen guardados.",
    "signInToCompareYourWorld": "Inicia sesión para comparar tu Mundo y activar la sincronización.",
    "chooseYourStartingWorld": "Elige tu Mundo de partida",
    "bothCopiesHaveTheSameContent": "Ambas copias tienen el mismo contenido.",
    "keepTheWorldOnThisDevice": "Conserva el Mundo de este dispositivo o usa la copia de tu cuenta. El Mundo local anterior y sus adjuntos se guardan en recuperación.",
    "keepThisDeviceSync": "Conservar este dispositivo y sincronizar",
    "useAccountCopySync": "Usar la copia de la cuenta y sincronizar",
    "cancel": "Cancelar",
    "reviewConcurrentChanges": "Revisar los cambios simultáneos",
    "chooseEachValueToKeepOther": "Elige cada valor que conservar. Los demás cambios se combinan automáticamente. Ambas versiones se pueden recuperar.",
    "applyReviewedChoices": "Aplicar las opciones revisadas",
    "syncingWorldAndAttachments": "Sincronizando el Mundo y los adjuntos…",
    "codexPages": "Páginas del Códice",
    "onThisDevice": "En este dispositivo",
    "waitingToSync": "Esperando para sincronizar",
    "syncing": "Sincronizando…",
    "upToDate": "Al día",
    "reviewNeeded": "Requiere revisión",
    "emptyText": "(texto vacío)",
    "emptyList": "(lista vacía)",
    "worldStructure": "Estructura del Mundo",
    "labelFacts": "Hechos",
    "labelEvents": "Eventos",
    "labelKnowledge": "Conocimiento",
    "labelAnnotations": "Anotaciones",
    "labelRelationships": "Relaciones",
    "labelAttachments": "Adjuntos",
    "labelCollections": "Colecciones",
    "labelFolders": "Carpetas",
    "paused": "En pausa",
    "addedCount_one": "{{count}} añadido",
    "addedCount_many": "{{count}} añadidos",
    "addedCount_other": "{{count}} añadidos",
    "removedCount_one": "{{count}} eliminado",
    "removedCount_many": "{{count}} eliminados",
    "removedCount_other": "{{count}} eliminados",
    "changedCount_one": "{{count}} modificado",
    "changedCount_many": "{{count}} modificados",
    "changedCount_other": "{{count}} modificados",
    "removedValue": "Eliminado",
    "emptyValue": "Vacío"
  },
  "worldReviewTools": {
    "deletedEntry": "Entrada eliminada",
    "timeUnknown": "Tiempo desconocido",
    "storyTimeInterval": "Intervalo de tiempo de la historia",
    "relativeToEventPreserved": "Relativo a un evento (conservado)",
    "from": "Desde",
    "until": "Hasta",
    "characterKnowledge": "Conocimiento de los personajes",
    "couldNotCheckTheSavedManuscriptRetry": "No se pudo comprobar el manuscrito guardado. Reintenta.",
    "revisionTools": "Herramientas de revisión",
    "changeImpact": "Impacto de un cambio",
    "whatPointsToThisRecord": "¿Qué apunta a este registro?",
    "explicitLinksOnlyIncludingIndirectLinksChangingARecord": "Solo enlaces explícitos, incluidos los indirectos. Cambiar un registro no reescribe los que dependen de él.",
    "impactRecord": "Registro de impacto",
    "chooseARecord": "Elige un registro",
    "linkedRecordsWorldRevision": "registros enlazados · revisión del Mundo",
    "directLink": "Enlace directo",
    "missingSourceScene": "Falta la escena de origen",
    "noExplicitRecordLinksToThisEntryUnlinkedProse": "Ningún registro enlaza explícitamente con esta entrada. La prosa sin enlaces queda fuera de esta comprobación.",
    "whenDidTheyLearnIt": "¿Cuándo lo supieron?",
    "recordAcquisitionAndUseOnTheSameStoryTime": "Registra cuándo se adquiere y cuándo se usa en el mismo eje del tiempo de la historia. Las suposiciones y las creencias quedan aparte; el orden de los capítulos nunca se trata como tiempo de la historia.",
    "recordKnowledge": "Registrar conocimiento",
    "couldNotSaveCheckTheIntervalsOrCancelAnd": "No se pudo guardar. Revisa los intervalos o cancela y vuelve a abrir si el Mundo cambió.",
    "character": "Personaje",
    "knowledgeCharacter": "Personaje que sabe",
    "chooseACharacter": "Elige un personaje",
    "fact": "Dato",
    "knowledgeFact": "Dato conocido",
    "chooseAConfirmedWorldFact": "Elige un dato del mundo confirmado",
    "acquired": "Adquirido",
    "acquisitionSource": "Fuente de la adquisición",
    "noSourceAttached": "Sin fuente adjunta",
    "use": "Uso",
    "scene": "Escena",
    "chooseAScene": "Elige una escena",
    "knownInformation": "Información conocida",
    "belief": "Creencia",
    "guess": "Suposición",
    "passageSource": "Fuente del pasaje",
    "noPassageAttached": "Sin pasaje adjunto",
    "removeUse": "Quitar el uso",
    "addUse": "Añadir un uso",
    "confirmAndSave": "Confirmar y guardar",
    "cancel": "Cancelar",
    "missingFact": "Dato ausente",
    "atUnknownRelativeTime": "en un tiempo desconocido o relativo",
    "edit": "Editar",
    "couldNotRemoveTheRecordRefreshAndRetry": "No se pudo quitar el registro. Actualiza y reintenta.",
    "checkSavedKnowledge": "Comprobar el conocimiento guardado",
    "theWorldChangedSinceThisResultRunTheCheck": "El Mundo cambió desde este resultado. Vuelve a ejecutar la comprobación.",
    "recordedUseIsEarlierThanAcquisition": "El uso registrado es anterior a la adquisición",
    "recordedTimesAreInOrder": "Los tiempos registrados están en orden",
    "beliefOrGuessNotAKnowledgeConflict": "Creencia o suposición: no es un conflicto de conocimiento",
    "notEnoughInformationToCompare": "No hay información suficiente para comparar",
    "attachedPassagesMatchTheSavedText": "Los pasajes adjuntos coinciden con el texto guardado",
    "aSourceIsMissingStaleOrBelongsToAnother": "Falta una fuente, está desactualizada o pertenece a otra escena",
    "authorRecordedTimesPassagesAreNotVerified": "Tiempos registrados por el autor; los pasajes no se verifican",
    "openScene": "Abrir escena",
    "noConfirmedKnowledgeUsesToCompare": "No hay usos de conocimiento confirmados que comparar.",
    "openNamedScene": "Abrir {{title}}",
    "recordSummary": "Usos: {{count}} · {{lifecycle}} · Adquirido {{time}}",
    "checkSummary": "Comprobado a las {{time}} · {{count}} usos registrados. Actualiza tras editar la prosa.",
    "resultsLimitedTo500Records": "Resultados limitados a 500 registros",
    "linksAway": "a {{depth}} vínculos de distancia",
    "useNKind": "Usar {{n}} tipo",
    "useN": "Usar {{n}}",
    "useNSource": "Usar {{n}} fuente",
    "checking": "Comprobando…"
  },
  "worldSection": {
    "overview": "Resumen",
    "vault": "Bóveda",
    "timeline": "Cronología",
    "connections": "Conexiones",
    "references": "Referencias",
    "checks": "Comprobaciones",
    "analysis": "Análisis",
    "characters": "Personajes",
    "locations": "Lugares",
    "factions": "Facciones",
    "objects": "Objetos",
    "concepts": "Conceptos",
    "worldViews": "Vistas del mundo",
    "world": "Mundo",
    "browseByType": "Explorar por tipo",
    "filterByType": "Filtrar por tipo",
    "all": "Todos",
    "newEntry": "Nueva entrada",
    "cercaNelCodex": "Buscar en el Códice",
    "searchEntries": "Buscar entradas…",
    "entry": "entrada",
    "entries": "entradas",
    "alsoAliases": "También: {{aliases}}",
    "noEntriesYetCreateTheFirst": "Aún no hay entradas. Crea el primer personaje, lugar o facción.",
    "noEntryMatches": "Ninguna entrada coincide.",
    "editName": "Editar {{name}}",
    "edit": "Editar",
    "archive": "Archivar",
    "confirmArchive": "Confirmar el archivado",
    "notesAndSketches": "Notas y bocetos",
    "alsoKnownAs": "También conocido como",
    "addADescriptionOneLineThat": "Añade una descripción: una línea que diga qué es esto.",
    "none": "Ninguno",
    "yes": "Sí",
    "no": "No",
    "removedEntry": "Entrada eliminada",
    "unavailableEntry": "Entrada no disponible",
    "noNotesYetEditTheEntry": "Aún no hay notas. Edita la entrada para describirla.",
    "linkedScenes": "Escenas vinculadas",
    "showTheEntriesOfABook": "Mostrar las entradas de un libro",
    "allBooks": "Todos los libros",
    "bookLine": "Libro {{number}} · {{title}}",
    "inNoBookYet": "Aún en ningún libro",
    "scenesThatMentionThisEntryBy": "Aquí aparecen las escenas que mencionan esta entrada por su nombre o alias.",
    "facts": "Datos",
    "noFactRecordedFactsAreAdded": "No hay datos registrados. Los datos se añaden y se aprueban en Comprobaciones.",
    "relations": "Relaciones",
    "noRelationYet": "Aún no hay relaciones.",
    "proposed": " · propuesta",
    "viewAll": "Ver todo",
    "attachments": "Adjuntos",
    "attachAnImageToUseIt": "Adjunta una imagen para usarla como retrato.",
    "kib": "KiB",
    "open": "Abrir",
    "remove": "Quitar",
    "addAttachment": "Añadir adjunto",
    "stateAtStoryTime": "Estado en un momento de la historia",
    "tick": "Tick",
    "factsWithoutACompleteInterval": "datos sin un intervalo completo.",
    "selectAnEntry": "Selecciona una entrada",
    "charactersPlacesFactionsAndObjectsLive": "Aquí viven los personajes, lugares, facciones y objetos, con sus datos, relaciones y adjuntos.",
    "recentChanges": "Cambios recientes",
    "undoChange": "Deshacer el cambio",
    "worldTimeline": "Cronología del mundo",
    "eventsPeopleAndPlacesInA": "Eventos, personas y lugares en un contexto más amplio.",
    "noEventYet": "Aún no hay eventos",
    "addTheFirstEventWithA": "Añade el primer evento con un tiempo de la historia, o deja el tiempo sin definir hasta que lo sepas.",
    "tick2": "tick",
    "plotEvent": "Evento de la trama",
    "worldEvent": "Evento del mundo",
    "openScene": "Abrir escena",
    "unknownTime": "Tiempo desconocido",
    "unknown": "desconocido",
    "seeHowYourWorldSPeople": "Mira cómo se conectan las personas, los lugares y las ideas de tu mundo.",
    "connectionsView": "Vista de conexiones",
    "graph": "Grafo",
    "list": "Lista",
    "nothingToConnectYet": "Aún no hay nada que conectar",
    "createEntriesInTheCodexAnd": "Crea entradas en el Códice y relaciónalas en la vista de lista.",
    "selectedEntry": "Entrada seleccionada",
    "relationSummary": "Resumen de relaciones",
    "noSceneMentionsThisEntryYet": "Ninguna escena menciona esta entrada todavía.",
    "openInCodex": "Abrir en el Códice",
    "selectANodeToSeeIts": "Selecciona un nodo para ver sus relaciones y escenas.",
    "annotationsAnchoredInTheManuscriptAnd": "Anotaciones ancladas al manuscrito y los archivos que guardas para tu mundo.",
    "addFile": "Añadir archivo",
    "annotations": "Anotaciones",
    "selectTextInTheManuscriptAnd": "Selecciona texto del manuscrito y usa «Anotar» para anclar un recurso, una entidad o una nota.",
    "scene": "Escena",
    "device": "Recurso",
    "entity": "Entidad",
    "note": "Nota",
    "imagesPdfsNotesAndAudioYou": "Imágenes, PDF, notas y audio que adjuntas al mundo o a una entrada.",
    "linked": "Vinculado",
    "orphan": "Huérfano",
    "openFile": "Abrir archivo",
    "referenceDetails": "Detalles de la referencia",
    "textAnnotation": "Anotación de texto",
    "kind": "Tipo",
    "anchor": "Ancla",
    "concept": "Concepto",
    "created": "Creado",
    "anchorStatesValidStaleOrphanedAnd": "Los estados del ancla (válida, desactualizada, huérfana) y el reanclaje se calculan en Comprobaciones.",
    "attachment": "Adjunto",
    "type": "Tipo",
    "size": "Tamaño",
    "linkedTo": "Vinculado a",
    "added": "Añadido",
    "confirmRemove": "Confirmar la eliminación",
    "selectAnAnnotationOrAFile": "Selecciona una anotación o un archivo.",
    "exploreTheShapeOfYourStory": "Explora la forma de tu historia: extensión, presencia y densidad a lo largo de las escenas.",
    "sceneLength": "Extensión de las escenas",
    "wordsPerScene": "Palabras por escena",
    "noScenesYet": "Aún no hay escenas.",
    "titleFmtWords": "{{title}}: {{fmt}} palabras",
    "entityDensity": "Densidad de entidades",
    "codexMentionsPerScene": "Menciones del Códice por escena",
    "titleMentionsMentions": "{{title}}: {{mentions}} menciones",
    "characterAppearanceMap": "Mapa de apariciones de personajes",
    "aDotWhereACharacterIs": "Un punto donde se nombra a un personaje en una escena",
    "addCharactersToTheCodexAnd": "Añade personajes al Códice y nómbralos en las escenas.",
    "thisScene": "Esta escena",
    "words": "Palabras",
    "paragraphs": "Párrafos",
    "sentencesEst": "Frases (est.)",
    "distinctWords": "Palabras distintas",
    "annotatedDevices": "Recursos anotados",
    "n1000Words": "/ 1.000 palabras",
    "repetitions": "Repeticiones",
    "exportHtml": "Exportar HTML",
    "exportTxt": "Exportar TXT",
    "events": "Eventos",
    "confirmedFacts": "Datos confirmados",
    "recentlyChanged": "Cambiado recientemente",
    "changesToTheWorldWillBe": "Los cambios en el mundo aparecerán aquí, cada uno con su opción de deshacer.",
    "undo": "Deshacer",
    "startHere": "Empieza aquí",
    "overviewEmptyLead": "Las personas, los lugares y los eventos de tu historia, vinculados a las escenas en las que aparecen.",
    "addACharacter": "Añadir un personaje",
    "addACharacterText": "Quién es, qué quiere y qué se interpone en su camino.",
    "addAPlace": "Añadir un lugar",
    "addAPlaceText": "Donde ocurren las escenas: una ciudad, un barco, una sola habitación.",
    "addAnEventText": "Algo que ocurre en la historia, con su fecha o sin ella.",
    "inThisWorld": "En este mundo",
    "createAnEntry": "Crear una entrada",
    "aCharacterAPlaceAFaction": "Un personaje, un lugar, una facción, un objeto o un concepto.",
    "addAnEvent": "Añadir un evento",
    "withAnExactStoryTimeOr": "Con un tiempo de la historia exacto o desconocido.",
    "runTheChecks": "Ejecutar las comprobaciones",
    "deterministicRulesOwnershipOrderAnchorsOrphans": "Propietarios, orden, revelaciones y relaciones a lo largo del tiempo, comparados con el texto.",
    "loadingTheWorld": "Cargando el mundo…",
    "maps": "Mapas",
    "openItsMap": "Abrir su mapa",
    "addAMap": "Añadir un mapa",
    "pinnedOn": "Marcado en",
    "typeCharacter": "Personaje",
    "typeLocation": "Lugar",
    "typeObject": "Objeto",
    "typeFaction": "Facción",
    "typeConcept": "Concepto",
    "annotationsToReAnchor_one": "{{count}} anotación por volver a anclar.",
    "annotationsToReAnchor_many": "{{count}} anotaciones por volver a anclar.",
    "annotationsToReAnchor_other": "{{count}} anotaciones por volver a anclar."
  }
}
